/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-unknown-property */
import React, { Fragment } from 'react';
import BEMHelper from 'react-bem-helper';
import PropTypes from 'prop-types';
import { isMobile } from '@ringcentral/rwc-utils/src/client-detection';
import SVGIcon from '../Icon/SVGIcon';

import Logo from '@ringcentral/rwc-branding/assets/images/logos/logo.rc_us.svg';
import OneTrustEntry from './OneTrustEntry';

import './style.less';
import partner1Img from './img/partner-1.png';
import partner2Img from './img/partner-2.png';
import partner3Img from './img/partner-3.png';

export const classes = new BEMHelper('Footer');

const COOKIE_PREFERENCES = 'cookie_preferences';

const allowedLinks = [
    'contact_us',
    'about',
    'partners',
    'legal',
    'privacy',
    COOKIE_PREFERENCES,
    'site_map',
];

const RCFooter = ({ links, ...props }) => {
    const filteredLinks = Object.keys(links)
        .filter(key => allowedLinks.includes(key))
        .reduce((arr, key) => {
            if (links[key].href || key === COOKIE_PREFERENCES) {
                arr.push(links[key]);
            }

            return arr;
        }, []);

    const footerLinks = filteredLinks.map((item, index, arr) => (
        <Fragment key={item.text + index}>
            {item.key === COOKIE_PREFERENCES ? (
                <OneTrustEntry text={item.text} />
            ) : (
                <a href={item.href} target='_blank' rel='noreferrer'>
                    {item.text}
                </a>
            )}
            {index === arr.length - 1 ? null : ' | '}
        </Fragment>
    ));

    return (
        <Fragment>
            <footer {...classes()}>
                <div {...classes('top')}>
                    <div {...classes('left')}>
                        <a href={props.logolink} target='_blank' rel='noreferrer'>
                            <SVGIcon icon={Logo} {...classes('logo')} />
                        </a>
                    </div>
                    <div {...classes('right')}>
                        <div {...classes('partners-wrapper')}>
                            <div {...classes('partners')}>
                                <a href={links.BBB.href} target='_blank' rel='noreferrer'>
                                    <img
                                        src={partner1Img}
                                        width='212'
                                        max-height='80'
                                        alt=''
                                    />
                                </a>
                            </div>
                            <div {...classes('partners')}>
                                <a href={links.skyhigh.href} target='_blank' rel='noreferrer'>
                                    <img
                                        src={partner2Img}
                                        width='35'
                                        max-height='35'
                                        alt=''
                                    />
                                </a>
                            </div>
                            <div {...classes('partners')}>
                                <a href={links.trustare.href} target='_blank' rel='noreferrer'>
                                    <img src={partner3Img} alt='' />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {!isMobile && (
                    <div {...classes('bottom')}>
                        <div {...classes('left')}>{props.copyright}</div>
                        <div {...classes('right')}>{footerLinks}</div>
                    </div>
                )}
            </footer>
            {isMobile && <OneTrustEntry text={links.cookie_preferences.text} />}
        </Fragment>
    );
};

RCFooter.propTypes = {
    links: PropTypes.object,
    copyright: PropTypes.string,
    logolink: PropTypes.string,
};

export default RCFooter;
